// src/com/bbs_pkg/BbsPkg.js
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import AnnounceBbs from './announce_bbs/AnnounceBbs';
import UpdateBbs from './update_bbs/UpdateBbs';
import VehAllocBbs from './veh_alloc_bbs/VehAllocBbs';
import UserBbsInfo from './user_bbs/UserBbsInfo';
import { AppMenuUrl } from '../../value/AppConst';

export default function BbsPkg({
    menu, parentMenu
}) {
    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = parentMenu
    ? <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />
    : null;

    // 공지사항, 배차현황 게시판, 업데이트 게시판, 사용자 게시판
    return(
        <TopViewControl>
            {
                (() => {
                    if(menu.menuUrl===AppMenuUrl.Bbs) return <AnnounceBbs viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.VehBbs) return <VehAllocBbs viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.BackBbs) return <UpdateBbs viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.UserBbs) return <UserBbsInfo viewServiceTags={viewServiceTags} />;
                    return null;
                })()
            }
        </TopViewControl>
    );
}
